<template>
  <div class="login-container">
    <!-- 左侧的盒子 -->
    <div class="left">
      <!-- 标题盒子 -->
      <div class="title-box">
        <div class="title">选择楼盘</div>
      </div>
      <!-- 表单 -->
      <el-form
        ref="ruleForm"
        label-width="43px"
        class="demo-ruleForm login-form"
      >
        <!-- 选择城市 -->
        <el-form-item>
          <el-cascader :props="props" @change="handleChangeValue"></el-cascader>
        </el-form-item>
      </el-form>
    </div>
    <!-- 右边的图片 -->
    <img class="bg" src="@/assets/login_banner_ele.png" alt="" />
  </div>
</template>

<script>
// getHouseByAreaApi
import { getAreaListApi } from '@/api/areaApi.js';
import { houseDropList } from '@/api/houseApi.js';
import { saveToken, getToken } from '@/utils/token.js';
import { getRolePermitAccountApi } from '@/api/user';
export default {
  name: 'login',
  data() {
    return {
      ruleForm: {
        mobile: '',
      },
      options: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          // console.log(level);
          const userInfo = JSON.parse(getToken('userInfo'));
          // console.log('userInfo', userInfo);
          let { areaId, roleType } = userInfo;
          if (level == 0) {
            getAreaListApi({ areaId, roleType }).then((res) => {
              if (res.code === 200) {
                // console.log(res.data, 'lalala');
                const arr = res.data.area.map((item) => {
                  return {
                    value: item.areaId,
                    label: item.areaName,
                    leaf: false,
                    // leaf: !item.houseDtos.length,
                  };
                });
                this.options = arr;
                resolve(arr);
              }
            });
          } else if (level == 1) {
            const { value } = node;
            const index = this.options.findIndex(
              (child) => child.value == value
            );
            houseDropList({ areaId: value, pageIndex: 1, pageSize: 999 }).then(
              (res) => {
                if (res.code === 200) {
                  const arr = res.data.dataList.map((item) => {
                    return {
                      value: item.houseId,
                      label: item.houseName,
                      leaf: true,
                    };
                  });
                  this.options[index].children = arr;
                  // console.log(this.options, 'this.options');
                  saveToken(JSON.stringify(this.options), 'options');
                  resolve(arr);
                }
              }
            );
            // console.log(value, 'node');
          }
        },
      },
      // 左侧间隙
      formLabelWidth: '60px',
    };
  },
  methods: {
    handleChangeValue(arr) {
      if (arr.length) {
        const houseId = arr[1];
        const userInfo = JSON.parse(getToken('userInfo'));
        userInfo.houseId = houseId;
        // console.log(houseId, userInfo);
        saveToken(JSON.stringify({ areaId: arr[0] }), 'areaId');
        saveToken(JSON.stringify(userInfo), 'userInfo');
        this.$store.dispatch('area/setAreaIdData', arr[0]);
        // this.$router.push('/home');
        getRolePermitAccountApi({
          houseId: userInfo.houseId,
        }).then((res) => {
          if (res.code === 200) {
            // console.log('结果：', res.data);
            let name = res.data[0].menu.url;
            this.$router.replace({
              // path: '/houseAdmin',
              name,
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  display: flex;
  align-items: center;
  background: linear-gradient(
    225deg,
    rgba(1, 198, 250, 1),
    rgba(20, 147, 250, 1)
  );
  justify-content: space-around;
  height: 100%;
  .left {
    width: 478px;
    height: 550px;
    background-color: #f5f5f5;
    padding-top: 44px;
    box-sizing: border-box;

    // 登录表单
    .login-form {
      padding-right: 41px;
      margin-top: 27px;

      // 更高的文本框
      .high-input > input {
        height: 45px;
        line-height: 45px;
      }
    }
    // 表单内部的 按钮
    .login-btn {
      width: 100%;
      margin-left: 0;
    }
    .reset-btn {
      margin-top: 28px;
    }
  }

  .title-box {
    display: flex;
    // 上下居中
    align-items: center;
    margin-left: 48px;
    img {
      margin-right: 16px;
      width: 22px;
      height: 17px;
    }
    .title {
      font-size: 24px;
      font-weight: 400;
      margin-right: 14px;
    }
    .line {
      width: 1px;
      background-color: #dfdfdf;
      margin-right: 12px;
      height: 28px;
    }
    .sub-title {
      font-size: 22px;
      font-weight: 400;
    }
  }
}
</style>
